/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained herein is, and remains
 * the property of Indigen Solutions and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { compact, flatten } from "lodash";

const parseAttributeString = (attrString = "") => {
    const matches = attrString.match(new RegExp(/id="([\s\S]*?)"/, "m"));
    if (!matches) return {};
    return { id: matches[1] };
};
const decodeHtml = htmlString => {
    const textAreaElement = document.createElement("textarea");
    textAreaElement.innerHTML = htmlString;
    return textAreaElement.value;
};
class TableOfContentsManager {
    /**
     *
     * @param sections
     */

    getConventionItems(convention) {
        const { caMeta, territories, activities, excludedActivities } = convention;
        let tableItems = [];
        if (caMeta.heading !== "") {
            const children = this.parseHtmlToSections(caMeta.heading);
            tableItems.push({
                title: "Textes de référence",
                key: "heading",
                id: "heading",
                children,
                level: 1,
            });
        }
        if (territories.length > 0) {
            const children = this.getItemGroupsChildren(territories);
            tableItems.push({
                title: "Territorial",
                key: "territorial",
                id: "territorial",
                children,
                level: 1,
            });
        }
        if (activities.length > 0) {
            const children = this.getItemGroupsChildren(activities);
            tableItems.push({
                title: "Professionnel",
                key: "activities",
                id: "activities",
                children,
                level: 1,
            });
        }
        if (excludedActivities.length > 0) {
            const children = this.getItemGroupsChildren(excludedActivities);
            tableItems.push({
                title: "Exclusions",
                key: "excludedActivities",
                id: "excludedActivities",
                children,
                level: 1,
            });
        }
        if (caMeta.annex && caMeta.annex !== "") {
            const children = this.parseHtmlToSections(caMeta.annex);
            tableItems.push({
                title: "Annexes",
                key: "annex",
                id: "annex",
                children,
                level: 1,
            });
        }
        return tableItems;
    }

    getItemGroupsChildren(itemGroups) {
        return flatten(
            itemGroups
                .filter(itemGroup => itemGroup.type === "text")
                .map(itemGroup => this.parseHtmlToSections(itemGroup.body))
        );
    }

    getArticleItems(article) {
        const headings = this.parseHtmlToSections(article.body);
        return headings;
    }

    parseHtmlToSections(htmlString, depth = 6, level = 1) {
        if (level >= depth) {
            return [];
        }
        // Adding delimiter at the end so that regex can recognize last block.
        const titleTag = `<h${level}`;
        const titleEndTag = `</h${level}>`;
        const blocksRegex = `\\${titleTag}.*?>(.*?)\\${titleEndTag}[\\s\\S]*?(?=\\${titleTag})`;
        const _text = htmlString + titleTag;
        const blocks = _text.match(new RegExp(blocksRegex, "gms"));
        if (!blocks) {
            return this.parseHtmlToSections(htmlString, depth, level + 1);
        }
        return compact(
            blocks.map(block => {
                const blockRegex = `\\${titleTag}(.*?)>(.*?)\\${titleEndTag}(.*)`;
                const blockMatches = block.match(new RegExp(blockRegex, "ms"));
                if (blockMatches === null) return null;
                const [, attributesStr, rawTitle, rawBody] = blockMatches;
                const attributes = parseAttributeString(attributesStr);
                const subtitleMatches = rawBody.match(new RegExp(/([\s\S]*?)(?=<h)/, "m"));
                if (subtitleMatches) {
                    return {
                        key: attributes.id,
                        title: rawTitle ? decodeHtml(rawTitle.trim()) : "",
                        level,
                        id: attributes.id,
                        children: this.parseHtmlToSections(rawBody, depth, level + 1),
                    };
                }
                return {
                    key: attributes.id,
                    title: rawTitle ? decodeHtml(rawTitle.trim()) : "",
                    level,
                    id: attributes.id,
                    children: [],
                };
            })
        );
    }
}

const tableOfContentsManager = new TableOfContentsManager();
export default tableOfContentsManager;
